import { get, post, deleted } from "../index";
import BannerRoutes from "./Banner.routes";

const BannerServices = {
  createBanner: async (obj) => {
    const result = await post(BannerRoutes.createBanner, obj);
    return result;
  },

  getAllBanners: async (obj) => {
    const result = await get(BannerRoutes.getBanners);
    return result;
  },

  deleteBanner: async (id) => {
    const result = await deleted(BannerRoutes.deleteBanner + `/${id}`);
    return result;
  },
}

export default BannerServices;